import { render, staticRenderFns } from "./RegisterTechnician.vue?vue&type=template&id=5efd3ba3&"
import script from "./RegisterTechnician.vue?vue&type=script&lang=js&"
export * from "./RegisterTechnician.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTechnician.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports